import { Card, Button, message } from "antd";
import { LinkOutlined, StarOutlined, StarFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import httpInjectorService from "../../../../../services/http-injector.service";

export default function TemplateCard({
  template,
  isHovered,
  isSelected,
  onHover,
  onLeave,
  onSelect,
  selectedSpace,
}) {
  const navigate = useNavigate();
  const [isStarred, setIsStarred] = useState(false);

  // Copy template link
  const handleCopyLink = async (e) => {
    e.stopPropagation();

    const link = `${window.location.origin}/admin/confluence/space/template`;

    try {
      await navigator.clipboard.writeText(link);
      message.success("Link copied!");
    } catch (err) {
      message.error("Failed to copy link");
    }
  };

  // Toggle star
  const handleStarClick = (e) => {
    e.stopPropagation();
    setIsStarred((prev) => !prev);
  };

  // Use template
  const handleUseTemplate = async (e) => {
    e.stopPropagation();
    if (!selectedSpace) return;

    try {
      const response = await httpInjectorService.templateDraftPage({
        space_id: selectedSpace.space_id,
        template_id: template.id,
      });

      if (response.status === "success" && response.data?.item_id) {
        navigate(
          `/admin/confluence/space/${selectedSpace.space_id}/page/${response.data.item_id}`
        );
      } else {
        console.error("Failed to create template draft:", response);
      }
    } catch (error) {
      console.error("Error using template:", error);
    }
  };

  return (
    <Card
      style={{
        width: 260,
        borderRadius: 10,
        cursor: "pointer",
        border: isSelected ? "2px solid #1677ff" : "1px solid #f0f0f0",
        transition: "all 0.2s ease",
        boxShadow: isHovered ? "0 4px 12px rgba(0,0,0,0.08)" : "none",
      }}
      onClick={onSelect}
      onMouseEnter={() => onHover(template.id)}
      onMouseLeave={onLeave}
    >
      {/* Top Section */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            background: template.color || "#884b9e",
            width: 40,
            height: 40,
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontWeight: 600,
          }}
        >
          {template.template_name?.[0]}
        </div>

        {/* Icons */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            opacity: isHovered ? 1 : 0,
            pointerEvents: isHovered ? "auto" : "none",
            transition: "opacity 0.2s",
          }}
        >
          <LinkOutlined
            onClick={handleCopyLink}
            style={{
              marginRight: 12,
              color: "#8c8c8c",
              cursor: "pointer",
            }}
          />

          {isStarred ? (
            <StarFilled
              onClick={handleStarClick}
              style={{ color: "#faad14", cursor: "pointer" }}
            />
          ) : (
            <StarOutlined
              onClick={handleStarClick}
              style={{ color: "#8c8c8c", cursor: "pointer" }}
            />
          )}
        </div>
      </div>

      {/* Title */}
      <div style={{ fontWeight: 600, fontSize: 16, marginTop: 16 }}>
        {template.template_name}
      </div>

      {/* Bottom Section */}
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ color: "#595959" }}>{template.categories}</span>

        {/* Use Button */}
        <Button
          size="small"
          onClick={handleUseTemplate}
          style={{
            backgroundColor: "#884b9e",
            borderColor: "#884b9e",
            color: "#fff",
            opacity: isHovered ? 1 : 0,
            pointerEvents: isHovered ? "auto" : "none",
            transition: "opacity 0.2s",
          }}
        >
          Use
        </Button>
      </div>
    </Card>
  );
}